






































































import { Vue, Component } from "vue-property-decorator";
import Navbar from "@/modules/home/components/Navbar.vue";
import { required, email } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";

const Auth = namespace("auth");
@Component({
  components: {
    navbar: Navbar,
  },
})
export default class ResetPassword extends Vue {
  @Auth.Action("resetPassword") sendResetPasswordLink!: (
    email: string
  ) => Promise<{}>;

  loading = false;
  resetSent = false;
  resetPassword = {
    email: "",
  };
  confirmResetPassword() {
    this.loading = true;
    this.sendResetPasswordLink(this.resetPassword.email)
      .then(() => {
        this.loading = false;
        this.resetSent = true;
      })
      .catch(() => {
        this.loading = false;
        this.resetSent = false;
      });
  }
  validations() {
    return {
      resetPassword: {
        email: {
          required,
          email,
        },
      },
    };
  }
}
